"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assignOfficeCsmApiResponseSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
exports.assignOfficeCsmApiResponseSchema = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string().uuid(),
        type: (0, api_1.apiEntityTypeSchema)('offices'),
        attributes: zod_1.z.object({
            assignedCsmId: zod_1.z.string().uuid().nullable(),
            updatedAt: zod_1.z.coerce.date(),
        }),
    }),
});
